import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectJsonQuery } from 'shared/selectors/results/selectJsonQuery';
import { selectResultPuids } from 'shared/selectors/results/selectResultPuids';
import { selectIsQaMode } from 'shared/selectors/selectIsQaMode';
import { getRailwayAndHighwayPuids } from 'shared/utils/adfox/getRailwayAndHighwayPuids';

import { isCommercial, offerTypeFromJsonQuery } from '../../packages/JsonQuery';

const commercialReg = /commercial$/gm;

export function usePuidsSelector(): Record<string, string | null> {
  const jsonQuery = useSelector(selectJsonQuery);
  const puids = useSelector(selectResultPuids);

  const isQaMode = useSelector(selectIsQaMode);

  return useMemo(() => {
    const completePuids: Record<string, string | null> = {
      ...getRailwayAndHighwayPuids(jsonQuery),
      ...puids,
    };

    /**
     * @description Сейчас существует баг, что для гаражей приходит puid2 = offer_commercial, а не offer_flat
     * Это происходит из-за того, что когда гаражи переезжали из коммерческой в жилую,
     * не поменяли отправляемый в jsonQuery _type
     */
    if (completePuids.puid2 && completePuids.puid2.match(commercialReg)) {
      const isCommercialListing = isCommercial(offerTypeFromJsonQuery(jsonQuery));

      if (!isCommercialListing) {
        completePuids.puid2 = completePuids.puid2.replace(commercialReg, 'flat');
      }
    }

    if (isQaMode) {
      completePuids.puid32 = 'test';
    }

    return completePuids;
  }, [isQaMode, jsonQuery, puids]);
}
